import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBulk = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M4 4H13.3889C14.1869 4 14.8333 4.59667 14.8333 5.33333V14H15.5556C16.3536 14 17 13.4033 17 12.6667V3.33333C17 2.59667 16.3536 2 15.5556 2H5.44444C4.64639 2 4 2.59667 4 3.33333V4ZM12.6667 5H3.33333C2.59667 5 2 5.63176 2 6.41176V15.5882C2 16.3682 2.59667 17 3.33333 17H12.6667C13.4033 17 14 16.3682 14 15.5882V6.41176C14 5.63176 13.4033 5 12.6667 5ZM12.3157 8.17785C12.5528 8.41499 12.5528 8.80011 12.3157 9.03724L7.45911 13.8938C7.22197 14.131 6.83685 14.131 6.59972 13.8938L4.17141 11.4655C3.93428 11.2284 3.93428 10.8433 4.17141 10.6062C4.40855 10.369 4.79367 10.369 5.03081 10.6062L7.03036 12.6038L11.4582 8.17785C11.6954 7.94072 12.0805 7.94072 12.3176 8.17785H12.3157Z",
		fill: "#0D2976"
	})
});
export default SvgBulk;
